import React, { Component } from 'react';

import '../css/addlightness.css';
import '../css/about.css';



export class Privacy extends Component {
  render() {
    return (
      <div className="about-page">
        <div className="about-image-top">
          <div className="about-top-texts">
            <p>Privacy statement</p>
          </div>
        </div>

        <div className="prose-container flexColumn flexCentered">
          <p className="about-p">This privacy policy applies to the Gridiron Football Legends app (hereby referred to as "Application") for mobile devices that was created by Super Fusion Games (hereby referred to as "Service Provider") as an Ad Supported service. This service is intended for use "AS IS".</p>
          <p className="about-p">
The Application collects information when you download and use it. This information may include information such as

* the time spent on the Application
* the operating system you use on your mobile device
* the Application does *not* gather precise information about the location of your mobile device.</p>

          <p className="about-p">
Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.


Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:
<br/>
<br/>
<a href="https://policies.google.com/privacy">Google Play Services</a>
<br/>
<a href=" https://support.google.com/admob/answer/6128543?hl=en">AdMob</a>
      </p>


          <p className="about-p">
The Service Provider may disclose User Provided and Automatically Collected Information:

as required by law, such as to comply with a subpoena, or similar legal process;
when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;
with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
      </p>
          <p className="about-p">
Opt-Out Rights
You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
      </p>

          <p className="about-p">
Children
The Service Provider does not use the Application to knowingly solicit data from or market to children unjder the age of 13.

The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (pvc@swportfolio.com) so that they will be able to take the necessary actions.
      </p>

          <p className="about-p">
This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.

      <br/>
      <br/>

This privacy policy is effective as of 12 Aug 2025.

      <br/>
      <br/>

By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.

      <br/>
      <br/>

If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at pvc@swportfolio.com.

      </p>

        </div>
      </div>
    );
  }
}
